import { Currency } from "@redotech/money/currencies";
import * as z from "zod/v4";

export const rescueModalDiscountSchema = z.union([
  z.object({
    discountType: z.literal("fixed_amount"),
    amount: z.object({ currencyCode: z.enum(Currency), value: z.string() }),
  }),
  z.object({ discountType: z.literal("percentage"), percentage: z.string() }),
]);
export type RescueModalDiscount = z.infer<typeof rescueModalDiscountSchema>;

export const rescueModalSchema = z.object({
  enabled: z.boolean(),
  discountCode: z.string().optional(),
  discount: rescueModalDiscountSchema.optional(),
});
export type RescueModal = z.infer<typeof rescueModalSchema>;

export const predictiveConversionSettingsSchema = z.object({
  enabled: z.boolean(),
  activeCheckoutHazardModel: z.object({ endpointName: z.string() }).optional(),
  rescueModal: rescueModalSchema.optional(),
});
export type PredictiveConversionSettings = z.infer<
  typeof predictiveConversionSettingsSchema
>;

export const predictiveConversionSettingsDefault: PredictiveConversionSettings =
  { enabled: false };
